import "core-js/modules/es6.function.name";
import "core-js/modules/es6.promise";
import _regeneratorRuntime from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";
import _toConsumableArray from "C:/Users/enoch/code/our-meeting-minutes-client/node_modules/@babel/runtime/helpers/toConsumableArray";
import { getMeetings, getPreviousMeetings, getSingleMeetingForCollection, storeMeeting, updateTheMeeting, destroyMeeting, archiveMeeting } from "src/models/Meeting";
import errorDialog from "src/functions/function-show-error-message";
import getErrorPayload from "src/functions/get-error-payload";
import { downloadFile } from "src/functions/download-file-from-server";
import { commitPagination, hasNextPage } from "src/store/utils/pagination"; // Init state

var initState = function initState() {
  return {
    meetings: [],
    previousMeetings: [],
    hasMoreMeetings: true,
    pagination: {
      currentPage: 0,
      total_pages: 1
    },
    meeting: "",
    meetingEmailRecipients: [],
    loading: {
      meetings: false,
      previousMeetings: false
    }
  };
}; // State object


var state = initState(); // Mutations

var mutations = {
  setMeetings: function setMeetings(state, payload) {
    state.meetings = payload;
  },
  setPreviousMeetings: function setPreviousMeetings(state, meetings) {
    state.previousMeetings = [].concat(_toConsumableArray(state.previousMeetings), _toConsumableArray(meetings));
  },
  clearPreviousMeetings: function clearPreviousMeetings(state) {
    state.previousMeetings = [];
  },
  updatePagination: function updatePagination(state, pagination) {
    state.pagination.currentPage = pagination.currentPage;
    state.pagination.total_pages = pagination.total_pages;
  },
  setMeeting: function setMeeting(state, payload) {
    state.meeting = payload;
  },
  setHasMoreMeetings: function setHasMoreMeetings(state, hasMore) {
    state.hasMoreMeetings = hasMore;
  },
  setMeetingsLoading: function setMeetingsLoading(state, payload) {
    state.loading.meetings = payload;
  },
  setPreviousMeetingsLoading: function setPreviousMeetingsLoading(state, payload) {
    state.loading.previousMeetings = payload;
  },
  setMeetingEmailRecipients: function setMeetingEmailRecipients(state, participants) {
    state.meetingEmailRecipients = _toConsumableArray(participants);
  },
  // addMeetingEmailRecipient(state, payload) {
  //   state.meetingEmailRecipients.push({email: payload});
  // },
  removeMeetingEmailRecipient: function removeMeetingEmailRecipient(state, recipient) {
    var index = state.meetingEmailRecipients.findIndex(function (item) {
      return item.email === recipient.email;
    });
    state.meetingEmailRecipients.splice(index, 1);
  },
  deleteMeetingInMeetings: function deleteMeetingInMeetings(state, id) {
    var index = state.meetings.findIndex(function (item) {
      return item.id === id;
    });
    state.meetings.splice(index, 1);
  },
  updateSinglePreviousMeeting: function updateSinglePreviousMeeting(state, updatedMeeting) {
    // Update in previousMeetings array
    var prevMeetingIndex = state.previousMeetings.findIndex(function (m) {
      return m.id === updatedMeeting.id;
    });

    if (prevMeetingIndex !== -1) {
      state.previousMeetings.splice(prevMeetingIndex, 1, updatedMeeting);
    }
  },
  RESET: function RESET(state) {
    var newState = initState();
    Object.keys(newState).forEach(function (key) {
      state[key] = newState[key];
    });
  }
}; // Actions

var actions = {
  setMeeting: function setMeeting(_ref, value) {
    var commit = _ref.commit;
    commit("setMeeting", value);
  },
  fetchFutureMeetings: function fetchFutureMeetings(_ref2) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, group, meetingsResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref2.commit;
              commit("setMeetingsLoading", true);
              _context.prev = 2;
              group = _this.getters["Group/group"];
              _context.next = 6;
              return getMeetings(group.id);

            case 6:
              meetingsResponse = _context.sent;
              commit("setMeetings", meetingsResponse.data.data);
              commit("setMeetingsLoading", false);
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              console.log(getErrorPayload(_context.t0));
              commit("setMeetingsLoading", false);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 11]]);
    }))();
  },
  initMeetingEmailRecipients: function initMeetingEmailRecipients(_ref3) {
    var commit = _ref3.commit;
    var participants = this.getters["User/participants"];
    commit("setMeetingEmailRecipients", participants);
  },
  fetchPreviousMeetings: function fetchPreviousMeetings(_ref4) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, state, group, nextPage, _response$data, _response$data2, _response$data2$meta, response;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref4.commit, state = _ref4.state;
              group = _this2.getters["Group/group"];

              if (hasNextPage(state, "pagination")) {
                _context2.next = 5;
                break;
              }

              commit("setHasMoreMeetings", false);
              return _context2.abrupt("return");

            case 5:
              commit("setPreviousMeetingsLoading", true);
              nextPage = state.pagination.currentPage + 1;
              _context2.prev = 7;
              _context2.next = 10;
              return getPreviousMeetings(group.id, nextPage);

            case 10:
              response = _context2.sent;
              commit("setPreviousMeetings", Array.isArray((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) ? response.data.data : []);
              commitPagination(commit, (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$meta = _response$data2.meta) === null || _response$data2$meta === void 0 ? void 0 : _response$data2$meta.pagination, {
                update: "updatePagination",
                setHasMore: "setHasMoreMeetings"
              });
              commit("setPreviousMeetingsLoading", false);
              _context2.next = 20;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](7);
              console.error("Error fetching previous meetings:", _context2.t0);
              commit("setPreviousMeetingsLoading", false);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[7, 16]]);
    }))();
  },
  updateSingleMeetingItem: function updateSingleMeetingItem(_ref5, meetingId) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var commit, group, response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref5.commit;
              _context3.prev = 1;
              group = _this3.getters["Group/group"];
              _context3.next = 5;
              return getSingleMeetingForCollection(group.id, meetingId);

            case 5:
              response = _context3.sent;
              commit("updateSinglePreviousMeeting", response.data);
              return _context3.abrupt("return", response.data);

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](1);
              console.error("Error updating meeting item:", _context3.t0);
              throw _context3.t0;

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 10]]);
    }))();
  },
  fetchMeetingById: function fetchMeetingById(_ref6, meetingId) {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var commit, dispatch, group, response;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref6.commit, dispatch = _ref6.dispatch;
              _context4.prev = 1;
              group = _this4.getters["Group/group"];
              _context4.next = 5;
              return getSingleMeetingForCollection(group.id, meetingId);

            case 5:
              response = _context4.sent;
              // Zet de meeting in de store
              commit("setMeeting", response.data); // Haal de agenda items op voor deze meeting

              _context4.next = 9;
              return dispatch("Agenda/fetchAgendaItemsByMeetingId", meetingId, {
                root: true
              });

            case 9:
              return _context4.abrupt("return", response.data);

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](1);
              console.error("Error fetching meeting by id:", _context4.t0);
              throw _context4.t0;

            case 16:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 12]]);
    }))();
  },
  createMeeting: function createMeeting(_ref7, request) {
    var _this5 = this;

    var commit = _ref7.commit;
    return new Promise(function (resolve) {
      var group = _this5.getters["Group/group"];
      storeMeeting(group.id, request).then(function (response) {
        resolve(response);
      }).catch(function (e) {
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
      });
    });
  },
  updateMeeting: function updateMeeting(_ref8, request) {
    var _this6 = this;

    var commit = _ref8.commit;
    commit("setMeetingsLoading", true);
    return new Promise(function (resolve, reject) {
      var group = _this6.getters["Group/group"];
      updateTheMeeting(group.id, request.meetingId, request.formData).then(function (response) {
        commit("setMeetingsLoading", false);
        resolve(response);
      }).catch(function (e) {
        commit("setMeetingsLoading", false);
        reject();
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
      });
    });
  },
  archiveTheMeeting: function archiveTheMeeting(_ref9, request) {
    var commit = _ref9.commit;
    var group = this.getters["Group/group"];
    return new Promise(function (resolve, reject) {
      archiveMeeting(group.id, request.meeting_id, request).then(function () {
        resolve();
      }).catch(function (e) {
        reject();
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
      });
    });
  },
  downloadMeetingArchive: function downloadMeetingArchive(_ref10, meeting) {
    var state = _ref10.state;
    var group = this.getters["Group/group"];
    var url = "/groups/".concat(group.id, "/meetings/").concat(meeting.id, "/downloadArchive/").concat(meeting.archive.id);
    var fileName = meeting.archive.name;
    downloadFile(url, fileName);
  },
  remove: function remove(_ref11, meetingId) {
    var commit = _ref11.commit;
    commit("setMeetingsLoading", true);
    var group = this.getters["Group/group"];
    return new Promise(function (resolve, reject) {
      destroyMeeting(group.id, meetingId).then(function (response) {
        commit("deleteMeetingInMeetings", meetingId);
        commit("setMeetingsLoading", false);
        resolve(response);
      }).catch(function (e) {
        reject();
        commit("setMeetingsLoading", false);
        errorDialog.showErrorMessageFromServer(getErrorPayload(e));
      });
    });
  }
}; // Getter functions

var getters = {
  meetings: function meetings(state) {
    return state.meetings;
  },
  previousMeetings: function previousMeetings(state) {
    return state.previousMeetings;
  },
  meeting: function meeting(state) {
    return state.meeting;
  },
  meetingsCount: function meetingsCount(state) {
    return state.previousMeetings.length + state.meetings.length;
  },
  meetingEmailRecipients: function meetingEmailRecipients(state) {
    return state.meetingEmailRecipients;
  },
  meetingsLoading: function meetingsLoading(state) {
    return state.loading.meetings;
  },
  previousMeetingsLoading: function previousMeetingsLoading(state) {
    return state.loading.previousMeetings;
  },
  hasMoreMeetings: function hasMoreMeetings(state) {
    return state.hasMoreMeetings;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};